import { get, isEmpty } from 'lodash';

const DEFAULT_PATTERN = /./;
const USERNAME_MIN_LENGTH = 5;
const USERNAME_MAX_LENGTH = 25;
const PASSWORD_MIN_LENGTH = 6;
const PASSWORD_MAX_LENGTH = 25;

const userNameValidate = value => {
	const pattern1 = new RegExp(
		'^([0-9A-Za-z!@#$%^ *_.])\\1{3,' + USERNAME_MAX_LENGTH.toString() + '}$',
		'g'
	);
	const pattern2 = new RegExp(
		'^[0-9A-Za-z!@#$%^ *_.]{5,' + USERNAME_MAX_LENGTH.toString() + '}$',
		'g'
	);
	return !pattern1.test(value) && pattern2.test(value);
};

const userNameErrorText = value => {
	if (value === '') {
		return 'Введите логин';
	}
	if (/[А-я]/g.test(value)) {
		return 'Вы вводите логин на кириллице – переключитесь на латиницу';
	}
	if (/[,?/=()+{}[\]|`~\\]/g.test(value)) {
		return 'Введите логин';
	}
	if (value.length < USERNAME_MIN_LENGTH) {
		return 'Логин слишком маленький';
	}
	if (value.length > USERNAME_MAX_LENGTH) {
		return 'Логин слишком большой';
	}
	return 'Некорректное значение для логина';
};

const validateCirillicSymbols = value => {
	return !/[(А-я)]/g.test(value);
};

const passwordValidate = value => {
	const pattern1 = new RegExp(
		'^([0-9A-Za-z!@#$%^ *_.])\\1{4,' + PASSWORD_MAX_LENGTH.toString() + '}$',
		'g'
	);
	const pattern2 = new RegExp(
		'^(?=.*\\d)(?=.*[A-Z])(?!.*[^0-9A-Za-z!@#$%^*_.])(.{6,' +
			PASSWORD_MAX_LENGTH.toString() +
			'})$',
		'g'
	);
	return !pattern1.test(value) && pattern2.test(value);
};

const passwordErrorText = value => {
	if (value === '') {
		return 'Введите пароль';
	}
	if (/[А-я]/g.test(value)) {
		return 'Вы вводите пароль на кириллице – переключитесь на латиницу';
	}
	if (/[,?/=()+{}[\]|`~\\]/g.test(value)) {
		return 'Введите пароль';
	}
	if (value.length < PASSWORD_MIN_LENGTH) {
		return 'Пароль слишком маленький';
	}
	if (value.length > PASSWORD_MAX_LENGTH) {
		return 'Пароль слишком большой';
	}
	return 'У вас небезопасный пароль. Рекомендуем сменить.';
};

const validationRules = {
	otpCode: {
		pattern: /\d{4}$/,
		errorText: 'Укажите код подтверждения',
	},
	username: {
		func: value => userNameValidate(value),
		errorTextFunc: value => userNameErrorText(value),
	},
	usernameOnChange: {
		func: value => validateCirillicSymbols(value),
		errorTextFunc: value => userNameErrorText(value),
	},
	password: {
		func: value => passwordValidate(value),
		errorTextFunc: value => passwordErrorText(value),
	},
	passwordOnChange: {
		func: value => validateCirillicSymbols(value),
		errorTextFunc: value => passwordErrorText(value),
	},
};

export const checkOneField = (value, fieldName, additionalOptions = '') => {
	const validationRule = get(validationRules, `${fieldName}`, null);
	const pattern = get(validationRule, 'pattern', null) || DEFAULT_PATTERN;
	const validationFunc =
		get(validationRule, 'func', null) || pattern.test.bind(pattern);
	const errorTextFunc = get(validationRule, 'errorTextFunc', false)
		? validationRule.errorTextFunc(value, additionalOptions)
		: false;
	const errorText =
		errorTextFunc ||
		get(validationRule, 'errorText', null) ||
		'Неверное значение';
	return validationFunc(value, additionalOptions) ? '' : errorText;
};